import { cacheTypes, getheader, getMethodByCallBack, postMethodByCallBack, postMethodByDispatcher, serverUrl, setErrorDialog } from "../../../store/api/CommonFunctions"
export const chequeStatuses =
{
    White: "White",
    in_1_RecieveCheque: "in_1_RecieveCheque",
    in_2_PutInAccount: "in_2_PutInAccount",
    in_3_GiveToCustomer: "in_3_GiveToCustomer",
    in_4_Cash: "in_4_Cash",
    in_5_NotCash: "in_5_NotCash",
    in_6_ReturnAndCustomerPay: "in_5_NotCash",
    in_7_ReturnAndCustomerNotPay: "in_7_ReturnAndCustomerNotPay",
    in_8_CustomerReturns: "in_8_CustomerReturns",
    in_8_CustomerReturns_PrvDurations: "in_8_CustomerReturns_PrvDurations",
    out_1_PayCheque: "out_1_PayCheque",
    out_2_PassCheque: "out_2_PassCheque",
    out_3_CustomerReturns: "out_3_CustomerReturns"
}
export const pChequeStatuses =
{
    White: "سفید",
    in_1_RecieveCheque: "نزد صندوق",
    in_2_PutInAccount: "نزد بانک",
    in_3_GiveToCustomer: "واگذار شده",
    in_4_Cash: "وصول شده",
    in_5_NotCash: "وصول نشده",
    in_6_ReturnAndCustomerPay: "برگشتی واگذار شده",
    in_7_ReturnAndCustomerNotPay: "برگشتی واگذار نشده",
    in_8_CustomerReturns: "واگذار شده برگشتی",
    in_8_CustomerReturns_PrvDurations: "واگذار شده برگشتی دوره قبل",
    out_1_PayCheque: "نزد اشخاص",
    out_2_PassCheque: "پاس شده",
    out_3_CustomerReturns: "برگشتی"
}
export function getAllMappings(onGetData) {
    getMethodByCallBack("api/DocumentsAPI/GetAllMappings", cacheTypes.Default, onGetData, "GET_ALL_MAPPINGS");
}
export function searchAllAccountLevel3ForModal(accountName, accountCode, take, parentID, parentHardCode, hasHardCode, onGetData) {
    if (!take || take === 0) {
        take = 10;
    }
    getMethodByCallBack(`api/DocumentsAPI/SearchAllLevel3?accountName=${accountName}&accountCode=${accountCode}&take=${take}&parentID=${parentID}&parentHardCode=${parentHardCode ?? ""}&hasHardCode=${hasHardCode ?? false}`,
        cacheTypes.NoCache, onGetData, "SEARCH_ALL_LEVEL3");
}
export function editAutoDocumentMapping(postData, onPostData) {
    postMethodByCallBack("api/DocumentsAPI/EditAutoMapping", postData, onPostData, "EDIT_AUTO_DOCUMENT_MAPPING");
}
export function getAccountLevelOList(onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountLevelOList`, cacheTypes.NoCache, onGetData, "GET_ACCOUNT_LEVELO");
}
export function getAccountLevelOneList(parentID, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountLevelOneList?parentID=${parentID}`, cacheTypes.NoCache, onGetData, "GET_ACCOUNT_LEVELOne");
}
export function getAccountLevelTwoList(parentID, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountLevelTwoList?parentID=${parentID}`, cacheTypes.NoCache, onGetData, "GET_ACCOUNT_LEVELTWO");
}
export function getAccountLevelThreeList(parentID, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountLevelThreeList?parentID=${parentID}`, cacheTypes.NoCache, onGetData, "GET_ACCOUNT_LEVELTHREE");
}
export function editAccount(postData, onPostData) {
    postMethodByCallBack("api/DocumentsAPI/EditAccount", postData, onPostData, "EDIT_ACCOUNT");
}
export function deleteAccount(level, id, onDelete) {
    getMethodByCallBack(`api/DocumentsAPI/DeleteAccount?level=${level}&&id=${id}`, cacheTypes.NoCache, onDelete, "DELETE_ACCOUNT");
}
export function addNewAccount(postData, onPostData) {
    postMethodByCallBack("api/DocumentsAPI/AddNewAccount", postData, onPostData, "ADD_NEW_ACCOUNT");
}
export function findSpecificAccount(accountName, skip, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/FindSpecificAccount?accountName=${accountName}&skip=${skip}`, cacheTypes.NoCache, onGetData, "FIND_SPECIFIC_ACCOUNT");
}
export function getDocumentNumber(onGetData) {
    getMethodByCallBack("api/DocumentsAPI/GetDocumentNewNumber", cacheTypes.NoCache, onGetData, "GET_DOCUMENT_NUMBER");
}
export function getCostCenterList(name, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetCostCenterList?centerName=${name}`, cacheTypes.NoCache, onGetData, "GET_COST_CENTERS");
}
export function addNewCostCenter(data, onPost) {
    postMethodByCallBack(`api/DocumentsAPI/AddNewCostCenter?getList=true`, data, onPost, "ADD_NEW_COST_CENTER");
}
export function deleteCostCenter(id, onDelete) {
    getMethodByCallBack(`api/DocumentsAPI/DeleteCostCenter?id=${id}&getList=true`, cacheTypes.NoCache, onDelete, "DELETE_COST_CENTER");
}
export function editCostCenter(data, onUpdate) {
    postMethodByCallBack(`api/DocumentsAPI/EditCostCenter?getList=true`, data, onUpdate, "EDIT_COST_CENTER");
}
export function getCostCenterLastCode(onGetCode) {
    getMethodByCallBack(`api/DocumentsAPI/GetCostCenterLastCode`, cacheTypes.NoCache, onGetCode, "COST_CENTER_LAST_CODE");
}
export function getDocument(documentID, onGetDocument) {
    getMethodByCallBack(`api/DocumentsAPI/GetDocument?documentID=${documentID}`, cacheTypes.NoCache, onGetDocument, "GET_DOCUMENT");
}
export function getDocumentIDByAttachment(attachmentID, attachmentType, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetDocumentIdByAttachment?attachmentID=${attachmentID}&attachmentType=${attachmentType}`, cacheTypes.NoCache, onGet, "GET_DOCUMENT_ID");
}
export function addEditDocument(data, onDone) {
    return dispatch => {
        fetch(serverUrl + `api/DocumentsAPI/AddEditDocument`, {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                setErrorDialog(dispatch, res.Message, "ثبت سند حسابداری");
                if (res.Document && Number(res.Document.DocumentID) > 0) {
                    onDone(res);
                }
                else {
                    onDone({ Document: data });
                }
            })
            .catch(e => {
                setErrorDialog(dispatch, e.message, "ثبت سند حسابداری");
                onDone({ Document: data });
                console.log("[ADD_EDIT_DOCUMENT]", e);
            })
    }
}
export function editDocumentRow(data, onEdit) {
    postMethodByCallBack(`api/DocumentsAPI/EditDocumentRow`, data, onEdit, "EDIT_DOCUMENT_Row");
}
export function searchAccountsLevel2(accountName, accountCode, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/SearchAccountsLevel2?accountName=${accountName}&accountCode=${accountCode}`, cacheTypes.NoCache, onGetData, "SEARCH_ACCCOUNT_LEVEL2");
}
export function searchAccountsLevel1(accountName, accountCode, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/SearchAccountsLevel1?accountName=${accountName}&accountCode=${accountCode}`, cacheTypes.NoCache, onGetData, "SEARCH_ACCCOUNT_LEVEL2");
}
export function searchAccountsLevel0(accountName, accountCode, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/SearchAccountsLevel0?accountName=${accountName}&accountCode=${accountCode}`, cacheTypes.NoCache, onGetData, "SEARCH_ACCCOUNT_LEVEL2");
}
export function copyDocument(documentID, onCopyDone) {
    getMethodByCallBack(`api/DocumentsAPI/CopyDocument?documentID=${documentID}`, cacheTypes.NoCache, onCopyDone, "GET_DOCUMENT");
}
export function getDraftDocuments(durationID, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetDraftDocuments?durationID=${durationID}`, cacheTypes.NoCache, onGetData, "GET_DRAFT_DOCUMENTS");
}
export function searchDocuments(data) {
    return dispatch => {
        dispatch({
            type: "SEARCH_DOCUMENTS_FILTER",
            data: { ...data }
        })
        dispatch(postMethodByDispatcher(`api/DocumentsAPI/SearchDocuments`, data, "SEARCH_DOCUMENTS", "جستجوی سند حسابداری"));
    }
}
export function deleteDocument(id, onDelete) {
    getMethodByCallBack(`api/DocumentsAPI/DeleteDocument?id=${id}`, cacheTypes.NoCache, onDelete, "DELETE_ACCOUNT");
}
export function resetDocumentSearchFilters(data) {
    return dispatch => {
        dispatch({
            type: "SEARCH_DOCUMENTS_FILTER",
            data: data ? { ...data } : null
        })
    }
}
export function balanceReport(data) {
    return dispatch => 
    {
        dispatch({
            type:"BALANCE_REPORT_FILTERS",
            data:data
        })
        dispatch(postMethodByDispatcher("api/DocumentsAPI/AccountingBalance", data, "BALANCE_REPORT", "تراز آزمایشی"));
    }
}
export function accountsBookReport(data) {
    return dispatch => {
        dispatch({
            type: "ACCOUNTS_BOOK_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/DocumentsAPI/AccountingBook", data, "ACCOUNTS_BOOK_REPORT", "دفتر حساب"));
    }
}
export function saveAccountCheckDescription(data, onSave) {
    postMethodByCallBack(`api/DocumentsAPI/SaveAccountCheckDescription`, data, onSave, "SAVE_ACCOUNT_CHECK");
}
export function deleteAccountCheckDescription(relationID, checkType, onDelete) {
    getMethodByCallBack(`api/DocumentsAPI/DeleteAccountCheckDescription?relationID=${relationID}&checkType=${checkType}`, cacheTypes.NoCache, onDelete, 'DeleteAccountCheck');
}
export function getAccountCheckDescriptionInfo(checkType, relationID, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountCheckDescriptionInfo?checkType=${checkType}&relationID=${relationID}`, cacheTypes.NoCache, onGet, "GetAccountCheckDescriptionInfo");
}
export function getCreditorDebtorList(data, onPost) {
    return dispatch => {
        dispatch({
            type: "CREDITOR_DEBTOR_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/DocumentsAPI/CreditorDebtorList", data, "CREDITOR_DEBTOR_LIST", "لیست بدهکاران/بستانکاران", onPost));
    }
}
export function getAttachmentList(documentID, onGet) {
    getMethodByCallBack(`api/Attachments/GetAttachmentList?parentID=${documentID}&attachmentType=DocumentAttachment`, cacheTypes.NoCache, onGet, "GetAttachmentList");
}
export function getPrvNextDocumentID(currentID, next, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetPrvNextDocumentID?currentID=${currentID}&next=${next}`, cacheTypes.NoCache, onGet, "GetPrvNextDocumentID");
}
export function makeDocumentPermanet(documentID, onDone) {
    getMethodByCallBack(`api/DocumentsAPI/MakeDocumentPermanet?documentID=${documentID}`, cacheTypes.NoCache, onDone, "MakeDocumentPermanet");
}
export function makeDocumentsPermanet(dateFrom, dateTo, numberFrom, numberTo, onDone) {
    getMethodByCallBack(`api/DocumentsAPI/MakeDocumentsPermanet?dateFrom=${dateFrom}&dateTo=${dateTo}&numberFrom=${numberFrom}&numberTo=${numberTo}`, cacheTypes.NoCache, onDone, "MakeDocumentsPermanet");
}
export function makeDocumentTemporary(documentID, onDone) {
    getMethodByCallBack(`api/DocumentsAPI/MakeDocumentTemporary?documentID=${documentID}`, cacheTypes.NoCache, onDone, "MakeDocumentPermanet");
}
export function addNewPos(name, onSuccess) {
    getMethodByCallBack(`api/DocumentsAPI/AddNewPOS?name=${name}`, cacheTypes.NoCache, onSuccess, "AddNewPOS");
}
export function getNextAccountCode(level, parentHardCode, onGetCode) {
    getMethodByCallBack(`api/DocumentsAPI/GetNextAccountCode?level=${level}&parentHardCode=${parentHardCode}`, cacheTypes.NoCache, onGetCode, "GetNextAccountCode");
}
export function addSpecialDocument(data, onAdd) {
    if (data?.DocumentType?.toLowerCase() === "guaranteecardsaleshare") {
        postMethodByCallBack(`api/DocumentsAPI/CreateDocumentForGuaranteeCardsSaleShare`, data, onAdd, "CreateDocumentForGuaranteeCardsSaleShare");
    }
    else {
        postMethodByCallBack(`api/DocumentsAPI/AddSpecialDocument`, data, onAdd, "AddSpecialDocument");
    }
}
export function addEditChequeFunction(data, onAddEdit) {
    postMethodByCallBack(`api/DocumentsAPI/AddEditChequeFunction`, data, onAddEdit, "AddEditChequeFunction");
}
export function getChequeFunction(functionID, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetChequeFunction?functionID=${functionID}`, cacheTypes.NoCache, onGet, "GetChequeFunction")
}
export function getChequeFunctionByChequeID(cheqStatus, cheqID, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetChequeFunctionByChequeID?cheqStatus=${cheqStatus}&cheqID=${cheqID}`, cacheTypes.NoCache, onGet, "GetChequeFunctionByChequeID")
}
export function searchForCheque(data, onSearchDone) {
    return dispatch => {
        dispatch({
            type: "CHEQ_SEARCH_FILTERS",
            data: data
        });
        dispatch(postMethodByDispatcher(`api/DocumentsAPI/SearchForCheque`, data, "SEARCH_CHEQUE", "جستجوی چک", onSearchDone))
    }
}
export function resetChequeFilters(data) {
    return dispatch => dispatch({
        type: "CHEQ_SEARCH_FILTERS",
        data: data
    });
}
export function addEditBankAccount(data, onAddEdit) {
    postMethodByCallBack(`api/DocumentsAPI/AddEditBankAccount`, data, onAddEdit, "AddEditBankAccount");
}
export function getAllBankAccount(searchPhrase, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetAllBankAccount?searchPhrase=${searchPhrase}`, cacheTypes.NoCache, onGet, "GetAllBankAccount");
}
export function getBankAccount(id, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetBankAccount?id=${id}`, cacheTypes.NoCache, onGet, "GetBankAccount");
}
export function deleteBankAccount(id, onDelete) {
    return () => {
        getMethodByCallBack(`api/DocumentsAPI/DeleteBankAccount?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteBankAccount");
    }
}
export function createChequeBook(data, onCreate) {
    postMethodByCallBack(`api/DocumentsAPI/CreateChequeBook`, data, onCreate, "CreateChequeBook");
}
export function getChequeListToPay(data, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetChequeListToPay?bankID=${data.BankID ?? ""}&cheqNumber=${data.ChequeNumber ?? ""}`, cacheTypes.NoCache, onGet, "GetChequeListToPay");
}
export function GetChequeListForChequeFunction(data, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetChequeListForChequeFunction?status=${data.Status}&accountID=${data.AccountID ?? 0}&&accountCat=${data.AccountCat ?? 0}&cheqNumber=${data.ChequeNumber ?? ""}`, cacheTypes.NoCache, onGet, "GetChequeListForChequeFunction");
}
export function deleteChequeFunction(functionID, onDelete) {
    getMethodByCallBack(`api/DocumentsAPI/DeleteChequeFunction?functionID=${functionID}`, cacheTypes.NoCache, onDelete, "DeleteChequeFunction");
}
export function getPayInCashTargetList(onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetPayInCashTargetList`, cacheTypes.NoCache, onGet, "GetPayInCashTargetList");
}
export function getAccountReport(data, onGetData) {
    return dispatch => {
        dispatch({
            type: "ACCOUNTS_REPORT_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher(`api/DocumentsAPI/GetAccountReport`, data, "GET_ACCOUNTS_REPORT", "گزارش مشاهده حساب ها", onGetData))
    };
}
export function getAccountBalanceReport(toDate, onGetData) {
    getMethodByCallBack(`api/DocumentsAPI/GetAccountBalanceReport?toDate=${toDate}`, cacheTypes.NoCache, onGetData, "GetAccountBalanceReport");
}
export function getBenefitItems(dateFrom, dateTo, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetBenefitItems?dateFrom=${dateFrom}&dateTo=${dateTo}`, cacheTypes.NoCache, onGet, "GetBenefitItems");
}
export function getChequesWithCloseDueDateList(onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetChequesWithCloseDueDateList`, cacheTypes.Default, onGet, "GetChequesWithCloseDueDateList");
}
export function mergeDocuments(startNumberFrom, mergeType, onMerge) {
    const method = mergeType?.toString() === "1" ? "MergeDocumentsByDay" : "MergeDocumentsBy15Day";
    getMethodByCallBack(`api/DocumentsAPI/${method}?startNumberFrom=${startNumberFrom}`, cacheTypes.NoCache, onMerge, "MergeDocuments");
}
export function sortDocuments(startNumberFrom, onSort) {
    getMethodByCallBack(`api/DocumentsAPI/SortDocuments?startNumberFrom=${startNumberFrom}`, cacheTypes.NoCache, onSort, "SortDocuments");

}
/**
 * 
 * @param {int} serviceID 
 * @param {string} serviceType 
 * @param {bigint} agencyID 
 * @param {function} onGet 
 */
export function getServiceAgencyAccountReport(serviceID, serviceType, agencyID, saleID, onGet) {
    getMethodByCallBack(`api/DocumentsAPI/GetServiceAgencyAccountReport?serviceID=${serviceID}&serviceType=${serviceType}&agencyID=${agencyID}&saleID=${saleID}`, cacheTypes.NoCache, onGet, "GetServiceAgencyAccountReport");
}
export function deleteCheque(chequeID, onDelete)
{
    getMethodByCallBack(`api/DocumentsAPI/DeleteCheque?chequeID=${chequeID}`, cacheTypes.NoCache, onDelete,"DeleteCheque");
}